import { useState, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, COMPANY } from "../lib/constants";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/commercial", label: "Commercial Cleaning" },
  { to: "/residential", label: "Residential Cleaning" },
  { to: "/book", label: "Book a Cleaning" },
  { to: "/employment", label: "Employment" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-testid="site-header">
      <div className="bg-charcoal-900 text-gray-300 text-xs">
        <div className="ubm-container flex items-center justify-between h-9">
          <span className="hidden sm:block">Locally operated &bull; Serving all of {COMPANY.region}</span>
          <a href={COMPANY.phoneLink} className="flex items-center gap-1.5 hover:text-primary transition-colors" data-testid="topbar-phone">
            <Phone size={13} /> {COMPANY.phoneDisplay}
          </a>
        </div>
      </div>
      <div className="ubm-container">
        <div className="flex items-center justify-between h-20 gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="header-logo">
            <img src={LOGO_URL} alt="United Building Maintenance logo" className="h-12 w-12 object-contain rounded bg-charcoal-900 p-1" />
            <div className="leading-tight hidden sm:block">
              <div className="font-display font-bold text-charcoal-900 text-lg">United Building Maintenance</div>
              <div className="text-[11px] uppercase tracking-wider text-gray-500">& Residential Cleaning Services</div>
            </div>
          </Link>

          <nav className="hidden xl:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium rounded-md transition-colors ${isActive ? "text-primary" : "text-charcoal-700 hover:text-primary"}`}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-2 shrink-0">
            <button onClick={() => nav("/commercial#quote")}
              className="border-2 border-charcoal-900 text-charcoal-900 hover:bg-charcoal-900 hover:text-white font-semibold px-4 py-2 rounded-md text-sm transition-colors"
              data-testid="header-quote-btn">Request a Quote</button>
            <button onClick={() => nav("/book")}
              className="bg-primary text-white hover:bg-primary-hover font-semibold px-4 py-2 rounded-md text-sm transition-colors"
              data-testid="header-book-btn">Book a Residential Cleaning</button>
          </div>

          <button className="xl:hidden text-charcoal-900" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden border-t border-gray-200 bg-white" data-testid="mobile-menu">
          <div className="ubm-container py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"}
                className={({ isActive }) => `px-3 py-2.5 rounded-md font-medium ${isActive ? "text-primary bg-primary/5" : "text-charcoal-800"}`}>
                {n.label}
              </NavLink>
            ))}
            <div className="flex flex-col gap-2 mt-3">
              <button onClick={() => nav("/commercial#quote")} className="border-2 border-charcoal-900 text-charcoal-900 font-semibold px-4 py-2.5 rounded-md">Request a Quote</button>
              <button onClick={() => nav("/book")} className="bg-primary text-white font-semibold px-4 py-2.5 rounded-md">Book a Residential Cleaning</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
